module.exports = __webpack_public_path__ + "src/app/uiComponents/studio/images/tablet-frame.png?90985a552a0e8a032abb615befe208ae";